function loadEntry(entryId, url, cssClsName) {
    var $entry = $('#edm-entry-' + entryId);
    var loadingCssCls = cssClsName || 'loading';

    $entry.addClass(loadingCssCls);

    return $.get(url, {
        'entry-id': entryId
    }).done(function(data) {
        $entry.replaceWith(data.htmls[Object.keys(data.htmls)[0]]);
        runScripts(data.scripts);
        if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
            $.extend(window.EDMDataStorage, data.dataStorage);
        }
    }).always(function(){
        $entry.removeClass(loadingCssCls);
    });
}


function loadEntryWithPost(entryId, url, payload, cssClsName){
    var $entry = $('#edm-entry-' + entryId);
    var loadingCssCls = cssClsName || 'loading';
    var load = payload||{};

    $entry.addClass(loadingCssCls);

    return $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        data: JSON.stringify(load),
        dataType: 'json'
    }).done(function(data) {
        $entry.replaceWith(data.htmls[Object.keys(data.htmls)[0]]);
        runScripts(data.scripts);
        if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
            $.extend(window.EDMDataStorage, data.dataStorage);
        }
    }).always(function(){
        $entry.removeClass(loadingCssCls);
    });
}

function runScripts(scripts) {
    if(scripts && Object.keys(scripts).length > 0) {
        for(var k in scripts) {
            scripts[k].forEach(function (script) {
                $.globalEval(decodeURIComponent(script)
                    .replace(/\\n/g, '')
                    .replace(/\\/g, ''));
            });
        }
    }
}

module.exports = {
    loadEntry: loadEntry,
    loadEntryWithPost: loadEntryWithPost
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/defer/loader.js
// module id = 121
// module chunks = 0 1 9 16 19 21